import { z } from "zod";

export const PreliminaryReportSchema = z.object({
    id: z.number().positive().min(1),
    stageId: z.number().positive().min(1),
    description: z.string().max(10240).nullable().optional(),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
});

export type PreliminaryReport = z.infer<typeof PreliminaryReportSchema>;
